import { render, staticRenderFns } from "./dialogEditAddress.vue?vue&type=template&id=18fc7b95"
import script from "./dialogEditAddress.vue?vue&type=script&lang=js"
export * from "./dialogEditAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports